module.exports = __webpack_public_path__ + "static/media/SM.a16a8e17.png";